import type {QueryClient} from '@tanstack/react-query';
import {CACHE_KEYS} from './useEntryManagementUpdate';

/**
 * エントリー管理関連の全キャッシュを無効化する
 * @param queryClient - React Queryのクライアントインスタンス
 * @param entryManagementId - オプション: 特定のエントリー管理IDのキャッシュも無効化
 */
export const invalidateEntryManagementCaches = async (
  queryClient: QueryClient,
  entryManagementId?: number,
): Promise<void> => {
  const promises = [
    queryClient.invalidateQueries({
      queryKey: [CACHE_KEYS.PAGINATED_ENTRY_MANAGEMENTS],
    }),
    queryClient.invalidateQueries({
      queryKey: [CACHE_KEYS.ENTRY_MANAGEMENTS],
    }),
    queryClient.invalidateQueries({
      queryKey: [CACHE_KEYS.ENTRY_MANAGEMENT_REMINDERS],
    }),
    queryClient.invalidateQueries({queryKey: ['entryCalendars']}),
    queryClient.invalidateQueries({queryKey: ['googleSyncFailures']}),
  ];

  if (entryManagementId !== undefined) {
    promises.push(
      queryClient.invalidateQueries({
        queryKey: [CACHE_KEYS.ENTRY_MANAGEMENT, entryManagementId],
      }),
    );
  }

  await Promise.all(promises);
};

/**
 * カレンダー関連のキャッシュを無効化する
 * TODOやカレンダーイベントの変更時に使用
 */
export const invalidateCalendarCaches = async (
  queryClient: QueryClient,
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({queryKey: ['entryCalendars']}),
    queryClient.invalidateQueries({queryKey: ['entryTodos']}),
    queryClient.invalidateQueries({queryKey: ['googleSyncFailures']}),
  ]);
};
